import { defineComponent as _defineComponent } from 'vue'
import ElImageViewer from "element-ui/packages/image/src/image-viewer";
import { ref, toRefs } from "../../../adapter-vue";
import { isUniFrameWork } from "../../../utils/env";

interface IProps {
  url: string;
  size?: string;
  borderRadius?: string;
  nick?: string;
  useSkeletonAnimation?: boolean;
  isavatar?: boolean;
}

interface IEmits {
  (key: "onLoad", e: Event): void;
  (key: "onError", e: Event): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    url: { default: "" },
    size: { default: "36px" },
    borderRadius: { default: "50%" },
    nick: { default: "" },
    useSkeletonAnimation: { type: Boolean, default: false },
    isavatar: { type: Boolean, default: false }
  },
  emits: ["onLoad", "onError"],
  setup(__props: any, { emit: emits }: { emit: ({
  (key: "onLoad", e: Event): void;
  (key: "onError", e: Event): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { url: string, size: string, borderRadius: string, nick: string, useSkeletonAnimation: boolean, isavatar: boolean }

const defaultAvatarUrl = ref("");



const {
  size: avatarSize,
  url: avatarImageUrl,
  borderRadius: avatarBorderRadius,
  useSkeletonAnimation: useAvatarSkeletonAnimation,
  nick: nick,
} = toRefs(props);

let reloadAvatarTime = 0;
const isImgLoaded = ref<boolean>(false);
const loadErrorInUniapp = ref<boolean>(false);
const showViewer = ref<boolean>(false);

function avatarLoadSuccess(e: Event) {
  isImgLoaded.value = true;
  emits("onLoad", e);
}

function avatarLoadFailed(e: Event) {
  reloadAvatarTime += 1;
  if (reloadAvatarTime > 3) {
    return;
  }
  if (isUniFrameWork) {
    loadErrorInUniapp.value = true;
  } else {
    (e.currentTarget as HTMLImageElement).src = defaultAvatarUrl.value;
  }
  emits("onError", e);
}
function showavatar() {
  if (props.isavatar && avatarImageUrl.value) {
    showViewer.value = true;
  }
}
function closeViewer() {
  showViewer.value = false;
}

return { __sfc: true,defaultAvatarUrl, emits, props, avatarSize, avatarImageUrl, avatarBorderRadius, useAvatarSkeletonAnimation, nick, reloadAvatarTime, isImgLoaded, loadErrorInUniapp, showViewer, avatarLoadSuccess, avatarLoadFailed, showavatar, closeViewer, ElImageViewer, isUniFrameWork }
}

})